import React from "react";
import { Button, Card, Dropdown, message, Modal, notification } from "antd";
import { connect } from "react-redux";
import { CSVLink } from "react-csv";
import moment from "moment";
import {
  getAllSalesByDuration,
  getAllSales,
  getBranchSales,
  getBranchSalesByDuration,
  getCashierSales,
  merchantHasSale,
  getAllPaymentLabel,
  sendSalesReportToEmail,
} from "../../../../redux/actions/saleActions";
import numberFormatter from "../../../../utils/numberFormatter";
import { parseExportData, parseReport } from "./functions";
import Transactions from "./Transactions";

import "./index.scss";
import PaymentMethodTotal from "./PaymentMethodTotal";
import strings from "../../../../strings";

class TodayReports extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      reports: [],
      products: [],
      spenders: [],
      transactions: [],
      duration: "today",
      currentPage: 1,
      filterValue: "",
      end: moment(),
      begin: moment(),
      isBranchSelected: false,
      selectedBranch: null,
      isPaymentTypeSelected: false,
      selectedPaymentType: null,
      searchTransactionId: null,
      filterByVat: false,
      paymentLabelLoading: false,
      allPaymentLabels: [],
      isExportingSales: false,
      exportData: [],
      sendingMailLoading: false,
    };

    this.csvLinkRef = React.createRef();
  }

  componentWillMount() {
    const { pageNumber, begin, end } = this.state;
    this.handleGetSalesRange(pageNumber, begin, end);
    // Only fetch sales for today's date range, not all sales
    this.handleGetPaymentOptions();
  }

  handleGetAllSales = (pageNumber = 1) => {
    // Clear any Present Filters
    const { user } = this.props;
    this.updateFilterValue("");
    console.log("Fetching new sales...");
    this.setState({
      loading: true,
    });

    if(user.business_branch){
        this.props
        .getBranchSales(
          {
            pageNumber,
            id: user.business_branch.id,
            type: "default"
          }
        )
        .then(response => {
          this.setState({
            loading: false,
            reports: parseReport(response?.data),
            totalRecords: Number(response.headers?.['Total-Count'] || response.headers?.['total-count'] || response.headers?.['total'] || 0),
            totalAmount: response.headers["total-amount"],
            totalRangeProfit: response.headers["total-range-profit"],
            amountInRange: response.headers["total-range-amount"],
            totalPaymentWithCard: response.headers["total-range-amount-with-card"],
            totalPaymentWithCash: response.headers["total-range-amount-with-cash"],
            totalPaymentWithMobile: response.headers["total-range-amount-with-mobile"],
            totalPaymentWithMTransfer: response.headers["total-range-amount-with-mtransfer"],
            currentPage: pageNumber,
          });
        })
        .catch(() => {
          this.setState({
            loading: false,
          });
          message.error(strings.errorFetchingRecord);
        });
    }else{
      this.props
      .getAllSales({current: pageNumber})
      .then(response => {
        this.setState({
          loading: false,
          reports: parseReport(response?.data),
          totalRecords: Number(response.headers?.['Total-Count'] || response.headers?.['total-count'] || response.headers?.['total'] || 0),
          totalAmount: response.headers["total-amount"],
          totalRangeProfit: response.headers["total-range-profit"],
          amountInRange: response.headers["total-range-amount"],
          totalPaymentWithCard: response.headers["total-range-amount-with-card"],
          totalPaymentWithCash: response.headers["total-range-amount-with-cash"],
          totalPaymentWithMobile: response.headers["total-range-amount-with-mobile"],
          totalPaymentWithMTransfer: response.headers["total-range-amount-with-mtransfer"],
          currentPage: pageNumber,
        });
      })
      .catch(() => {
        this.setState({
          loading: false,
        });
        message.error(strings.errorFetchingRecord);
      });
    }
  };

  handleGetPaymentOptions = async () => {
    this.setState({
      paymentLabelLoading: true
    })
    this.props.getAllPaymentLabel()
    .then((res) => {
      this.setState({
        paymentLabelLoading: false,
        allPaymentLabels: res.data,
      })
    })
    .catch((err) => {
      this.setState({
        paymentLabelLoading: false
      })
      message.error(`unable to get payment options, ${err.message}`);
    });
  };

  handleGetSalesByPaymentType = (selectedPaymentType, pageNumber, pageSize) => {
    const { begin, end,  } = this.state;
    const { allBranches, user, getBranchSalesByDuration } = this.props;

    const homBranch = allBranches && allBranches.find(branch => branch.name.toLowerCase().includes("home"));

    const staff_id = user.business_branch ? user.id : null;
    const chosenBranch = user.business_branch ? user.business_branch.id : homBranch.id

    let type = "default";
    this.setState({ loading: true });
    getBranchSalesByDuration(
      begin.format().split("T")[0],
      end.format().split("T")[0],
      chosenBranch, 
      pageNumber, 
      type, 
      selectedPaymentType,
      staff_id
    )
    .then((response) => {
      if (response?.data.length > 0) {
        this.props.merchantHasSale(true);
      }
      this.setState({
        reports: parseReport(response?.data),
        totalRecords: Number(response.headers?.['Total-Count'] || response.headers?.['total-count'] || response.headers?.['total'] || 0),
        loading: false,
        totalAmount: response.headers["total-amount"],
        totalRangeProfit: response.headers["total-range-profit"],
        amountInRange: response.headers["total-range-amount"],
        totalPaymentWithCard:
          response.headers["total-range-amount-with-card"],
        totalPaymentWithCash:
          response.headers["total-range-amount-with-cash"],
        totalPaymentWithMobile:
          response.headers["total-range-amount-with-mobile"],
        totalPaymentWithMTransfer:
          response.headers["total-range-amount-with-mtransfer"],
        begin,
        end,
        currentPage: pageNumber,
      });
    })
    .catch((err) => {
      console.log("err",err);
      message.error(strings.errorFetchingRecord);
      this.setState({ loading: false })
    })
  }

  handleGetSalesRange(pageNumber, begin, end, id) {
    // Clear any Present Filters
    const { user } = this.props;
    const { isBranchSelected, selectedBranch } = this.state;
    this.updateFilterValue("");
    this.setState({
      loading: true,
    });
/* begin.format().split("T")[0],
      end.format().split("T")[0],
      chosenBranch, 
      pageNumber, 
      type, 
      selectedPaymentType,
      staff_id*/ 
      const type = "default";
    if(user.business_branch){
      if(user.role.id === 3 || user.role.id === 2){
        this.props
        .getBranchSalesByDuration(
          begin.format().split("T")[0],
          end.format().split("T")[0],
          user.business_branch.id,
          pageNumber,
          type,
          null,
          user.id,
        )
        .then(response => {
          this.setState({
            reports: parseReport(response?.data),
            totalRecords: Number(response.headers?.['Total-Count'] || response.headers?.['total-count'] || response.headers?.['total'] || 0),
            loading: false,
            totalAmount: response.headers["total-amount"],
            totalRangeProfit: response.headers["total-range-profit"],
            amountInRange: response.headers["total-range-amount"],
            totalPaymentWithCard:
              response.headers["total-range-amount-with-card"],
            totalPaymentWithCash:
              response.headers["total-range-amount-with-cash"],
            totalPaymentWithMobile:
              response.headers["total-range-amount-with-mobile"],
            totalPaymentWithMTransfer:
              response.headers["total-range-amount-with-mtransfer"],
            begin,
            end,
            currentPage: pageNumber,
          });
        })
        .catch(() => {
          message.error(strings.errorFetchingRecord);
        });
      }else{
        const id = user.business_branch.id;
        const type = "default";
        this.props
        .getBranchSalesByDuration(
          begin.format().split("T")[0],
          end.format().split("T")[0],
          id,
          pageNumber,
          type
        )
        .then(response => {
          this.setState({
            reports: parseReport(response?.data),
            totalRecords: Number(response.headers?.['Total-Count'] || response.headers?.['total-count'] || response.headers?.['total'] || 0),
            loading: false,
            totalAmount: response.headers["total-amount"],
            totalRangeProfit: response.headers["total-range-profit"],
            amountInRange: response.headers["total-range-amount"],
            totalPaymentWithCard:
              response.headers["total-range-amount-with-card"],
            totalPaymentWithCash:
              response.headers["total-range-amount-with-cash"],
            totalPaymentWithMobile:
              response.headers["total-range-amount-with-mobile"],
            totalPaymentWithMTransfer:
              response.headers["total-range-amount-with-mtransfer"],
            begin,
            end,
            currentPage: pageNumber,
          });
        })
        .catch(() => {
          message.error(strings.errorFetchingRecord);
        });
      }
      
    }else{
      if(id){
        const type = "default";
        this.props
        .getBranchSalesByDuration(
          begin.format().split("T")[0],
          end.format().split("T")[0],
          id = id,
          pageNumber,
          type
        )
        .then(response => {
          this.setState({
            reports: parseReport(response?.data),
            totalRecords: Number(response.headers?.['Total-Count'] || response.headers?.['total-count'] || response.headers?.['total'] || 0),
            loading: false,
            totalAmount: response.headers["total-amount"],
            totalRangeProfit: response.headers["total-range-profit"],
            amountInRange: response.headers["total-range-amount"],
            totalPaymentWithCard:
              response.headers["total-range-amount-with-card"],
            totalPaymentWithCash:
              response.headers["total-range-amount-with-cash"],
            totalPaymentWithMobile:
              response.headers["total-range-amount-with-mobile"],
            totalPaymentWithMTransfer:
              response.headers["total-range-amount-with-mtransfer"],
            begin,
            end,
            currentPage: pageNumber,
          });
        })
        .catch(() => {
          message.error(strings.errorFetchingRecord);
        });
      }else if(isBranchSelected){
        const type = "default";
        this.props
        .getBranchSalesByDuration(
          begin.format().split("T")[0],
          end.format().split("T")[0],
          id = selectedBranch,
          pageNumber,
          type
        )
        .then(response => {
          this.setState({
            reports: parseReport(response?.data),
            totalRecords: Number(response.headers?.['Total-Count'] || response.headers?.['total-count'] || response.headers?.['total'] || 0),
            loading: false,
            totalAmount: response.headers["total-amount"],
            totalRangeProfit: response.headers["total-range-profit"],
            amountInRange: response.headers["total-range-amount"],
            totalPaymentWithCard:
              response.headers["total-range-amount-with-card"],
            totalPaymentWithCash:
              response.headers["total-range-amount-with-cash"],
            totalPaymentWithMobile:
              response.headers["total-range-amount-with-mobile"],
            totalPaymentWithMTransfer:
              response.headers["total-range-amount-with-mtransfer"],
            begin,
            end,
            currentPage: pageNumber,
          });
        })
        .catch(() => {
          message.error(strings.errorFetchingRecord);
        });
      }else{
        this.props
        .getAllSalesByDuration(
          begin.format().split("T")[0],
          end.format().split("T")[0],
          pageNumber
        )
        .then(response => {
          this.setState({
            reports: parseReport(response?.data),
            totalRecords: Number(response.headers?.['Total-Count'] || response.headers?.['total-count'] || response.headers?.['total'] || 0),
            loading: false,
            totalAmount: response.headers["total-amount"],
            totalRangeProfit: response.headers["total-range-profit"],
            amountInRange: response.headers["total-range-amount"],
            totalPaymentWithCard:
              response.headers["total-range-amount-with-card"],
            totalPaymentWithCash:
              response.headers["total-range-amount-with-cash"],
            totalPaymentWithMobile:
              response.headers["total-range-amount-with-mobile"],
            totalPaymentWithMTransfer:
              response.headers["total-range-amount-with-mtransfer"],
            begin,
            end,
            currentPage: pageNumber,
          });
        })
        .catch(() => {
          message.error(strings.errorFetchingRecord);
        });
      }
    }
  }

  handleSelectPaymentType = (value, paymentType) => {
    if(value){
      return this.setState({
        isPaymentTypeSelected: value,
        selectedPaymentType: paymentType
      });
    }

    this.setState({
      isPaymentTypeSelected: value,
      selectedPaymentType: paymentType
    });
  }

  handleGetSalesByTransactionId = (transactionId, pageNumber, pageSize) => {
    const { selectedBranch, selectedPaymentType, begin, end  } = this.state;
    const { allBranches, getBranchSalesByDuration } = this.props;
    let chosenBranch;
    if(!selectedBranch){
      const homBranch = allBranches && allBranches.find(branch => branch.name.toLowerCase().includes("home"));
      chosenBranch = homBranch.id;
    }else{
      chosenBranch = selectedBranch
    }
  
    this.setState({ loading: true });
    getBranchSalesByDuration(
      begin.format().split("T")[0],
      end.format().split("T")[0],
      chosenBranch,
      pageNumber,
      "default",
      selectedPaymentType,
      null,
      transactionId
    )
    .then((response) => {
      if (response?.data.length > 0) {
        merchantHasSale(true);
      }
      this.setState({
        reports: parseReport(response?.data),
        totalRecords: Number(response.headers?.['Total-Count'] || response.headers?.['total-count'] || response.headers?.['total'] || 0),
        loading: false,
        totalAmount: response.headers["total-amount"],
        totalProfit: response.headers["total-profit"],
        amountInRange: response.headers["total-range-amount"],
        totalPaymentWithCard: response.headers["total-amount-with-card"],
        totalPaymentWithCash: response.headers["total-amount-with-cash"],
        totalPaymentWithMobile: response.headers["total-amount-with-mobile"],
        totalPaymentWithMTransfer:
          response.headers["total-amount-with-mtransfer"],
        begin: begin,
        end: end,
        currentPage: Number(response.headers.page),
        pageSize: Number(response.headers["per-page"])
      });
    })
    .catch((err) => {
      console.log("err",err);
      message.error(strings.errorFetchingRecord);
      this.setState({ loading: false })
    });
  }

  resetTransactions = (transactions = []) => {
    this.setState({
      reports: transactions,
    });
  };

  updateFilterValue = filterValue =>{
    const { pageNumber, begin, end } = this.state;
    if(filterValue !== ""){
      let filtered;
      if(!isNaN(filterValue)){
        filtered = filterValue;
      }else if(filterValue.toLowerCase().includes("bank transfer")){
        filtered = `is_paid_with_mtransfer`;
      }else if(filterValue.toLowerCase().includes("wallet")){
        filtered = `is_paid_with_customer_account`;
      } else if(filterValue.toLowerCase().includes("payment label")){
        filtered = `payment_label`;
      }else if(filterValue === "Split payment"){
        filtered = `split_payment`;
      }else{
        filtered = `is_paid_with_${filterValue.toLowerCase()}`;
      }

      this.handleSelectPaymentType(true, filtered);
      this.handleGetSalesByPaymentType(filtered);
      const namey = this.state.allPaymentLabels.find(label => label.id == filterValue);
      return this.setState({ 
        filterValue: filtered, 
        paymentName: !isNaN(filterValue) ? namey.label_name : filterValue
      })
    }

    this.setState({ filterValue: "" });
    // this.handleGetSalesRange(pageNumber, begin, end);
  }

    handleBranchSelect = value => {
      const { pageNumber, begin, end } = this.state;
      this.setState({ selectedBranch: value });
      if(this.props.allBranches.length === 1) return this.handleGetSalesRange(1, begin, end);
      this.setState({ isBranchSelected: true, selectedBranch: value });
      this.handleGetSalesRange(1, begin, end, value);
   }

  handleTransactionIdSelect = value => {
    this.setState({ 
      searchTransactionId: value 
    });

    this.handleGetSalesByTransactionId(value, 1);
  }

  handleSendSalesToMail = () => {
    const { begin, end } = this.state;
    this.setState({ sendingMailLoading: true })
    if(begin && end) return this.props
    .sendSalesReportToEmail(
      begin.format().split("T")[0], 
      end.format().split("T")[0]
    )
    .then(res => {
      if(res.status === 200 ){
        Modal.success({
          title: res.data.message,
          onOk: () => this.setState({ sendingMailLoading: false })
        })
      }
    })
    .catch(err => {
      Modal.error({
        title: `Unable to send report to mail ${err?.response ? err.response.data.message : err.message}`,
        onOk: this.setState({ sendingMailLoading: false })
      })
    });
  }

  handleSalesExport = async done => {
      const { begin, end } = this.state;
      const { user } = this.props;
  
      notification.info({
        message: strings.exportTransactions,
        description: strings.yourDownloadWillStart,
        duration: 2,
        style: {
          top: "3rem",
        },
      });
  
      if (begin && end) {
        if(user.business_branch){
          const response = await this.props.getBranchSalesByDuration(
            begin.format().split("T")[0],
            end.format().split("T")[0],
            user.business_branch.id,
            null,
            "export",
            null,
            user.id,
          ).catch(err => {
            console.log(err);
            this.setState({ isExportingSales: false });
            message.error(strings.errorFetchingSalesRecord);
          });
    
          const resp = parseReport(response?.data);
    
          const exportData = parseExportData(resp);
    
          this.setState({ isExportingSales: false, exportData });
    
          setTimeout(() => {
            const downloadBtn = document.getElementById("csvDownloadBtn");
    
            downloadBtn && downloadBtn.click();
          }, 1000);
        }else{
          const response = await this.props.getAllSalesByDuration(
            begin.format().split("T")[0],
            end.format().split("T")[0],
            null,
            "export"
          ).catch(err => {
            console.log(err);
            this.setState({ isExportingSales: false });
    
            message.error(strings.errorFetchingSalesRecord);
          });
    
          const resp = parseReport(response?.data);
    
          const exportData = parseExportData(resp);
    
          this.setState({ isExportingSales: false, exportData });
    
          setTimeout(() => {
            const downloadBtn = document.getElementById("csvDownloadBtn");
    
            downloadBtn && downloadBtn.click();
          }, 1000);
        }
      }
    };

  render() {
    const {
      reports,
      totalRecords,
      currentPage,
      amountInRange,
      totalRangeProfit,
      totalPaymentWithCard,
      totalPaymentWithCash,
      totalPaymentWithMobile,
      totalPaymentWithMTransfer,
      filterValue,
      begin,
      end,
      selectedBranch,
      allPaymentLabels,
      isExportingSales,
      exportData,
      sendingMailLoading,
    } = this.state;

    const { user } = this.props;

    const acceptedHeaders = [
      {
        label: strings.customerName,
        key: "customerName",
      },
      {
        label: strings.total,
        key: "total",
      },
      {
        label: strings.date,
        key: "created_at",
      },
      {
        label: strings.paymentType,
        key: "paymentType",
      },
      {
        label: strings.totalSellingPrice,
        key: "total_selling_price",
      },
      {
        label: strings.totalCostPrice,
        key: "total_cost_price",
      },
      // {
      //   label: "Customer Email",
      //   key: "customer.email",
      // },
      // {
      //   label: "Customer Phone",
      //   key: "customer.phone_number",
      // },
      // {
      //   label: "Cash Payment",
      //   key: "is_paid_with_cash",
      // },
      // {
      //   label: "Card Payment",
      //   key: "is_paid_with_card",
      // },
      // {
      //   label: "Mobile Payment",
      //   key: "is_paid_with_mobile",
      // },
      {
        label: strings.appliedDiscount,
        key: "has_discount",
      },
      {
        label: strings.discountAmount,
        key: "discount_amount",
      },
      {
        label: strings.paymentReference,
        key: "payment_reference",
      },
      {
        label: strings.channel,
        key: "channel",
      },
      {
        label: strings.profit,
        key: "total_profit",
      },
      {
        label: "Staff Email",
        key: "staff_email",
      },
      {
        label: "Product Details",
        key: "products",
      },
      {
        label: strings.noOfItems,
        key: "transactions.length",
      },
    ];

    const isAdmin = user.role_id === 1;
    const isAdminIsManager =
    user.role_id === 1 || (user.role && user.role.id === 2);

    const items = [
      {
        key: '1',
        label: (
          <Button
            style={{ width: "100%" }}
            onClick={this.handleSendSalesToMail}
            loading={sendingMailLoading}
          >
            {strings.sendReportToMail}
          </Button>
        ),
      }
    ]

    return (
      <main>
        <Card
          title={`${strings.todaysSales}:
          ${this.props.user.currency ||
            this.props.user.employer.currency}${numberFormatter(
            amountInRange || 0
          )}
          (${totalRecords || 0} ${strings.transaction}${
            totalRecords > 1 ? "s" : ""
          })`}
          loading={this.state.loading}
          extra={
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div style={{ display: "flex", alignItems: "center" }}>  
                {isAdminIsManager && (
                  <Dropdown  menu={{ items }}>
                    <Button
                      style={{ marginLeft: "1.5rem" }}
                      loading={isExportingSales || sendingMailLoading}
                      onClick={() => {
                        this.handleSalesExport();
                      }}
                      type="primary"
                    >
                      {strings.export}
                    </Button>
                  </Dropdown>
                )}
                
                {exportData.length > 0 && (
                  <CSVLink
                    id="csvDownloadBtn"
                    data={exportData}
                    headers={acceptedHeaders}
                    filename={`${user.business_branch ? user.business_branch.name: "Home"}_branch_today's_sales.csv`}
                    // asyncOnClick={true}
                    ref={this.csvLinkRef}
                    target="_blank"
                    children=""
                  />
                )}
              </div>
            </div>
          }
        >
          <div style={{ display: "flex" }}>
            {isAdmin && (
              <span style={{ margin: "0 10px" }}>
                {strings.totalProfit}: {totalRangeProfit}
              </span>
            )}

            <PaymentMethodTotal
              user={user}
              totalPaymentWithCard={totalPaymentWithCard}
              totalPaymentWithCash={totalPaymentWithCash}
              totalPaymentWithMTransfer={totalPaymentWithMTransfer}
              totalPaymentWithMobile={totalPaymentWithMobile}
              filterValue={filterValue}
            />
          </div>

          <section className="invoices-table mt-40">
            <Transactions
              transactions={reports || []}
              total={totalRecords}
              currentPage={currentPage}
              resetTransactions={this.resetTransactions}
              getAllSales={pageNumber => {
                this.setState({
                  loading: true,
                });
                this.handleGetAllSales(pageNumber);
              }}
              getSalesRange={pageNumber => {
                this.setState({
                  loading: true,
                });
                this.handleGetSalesRange(pageNumber, begin, end);
              }}
              updateFilterValue={this.updateFilterValue}
              handleSelectPaymentType={this.handleSelectPaymentType}
              handleTransactionIdSelect={this.handleTransactionIdSelect}
              loading={this.state.loading}
              user={this.props.user}
              begin={begin}
              end={end}
              handleBranchSelect={this.handleBranchSelect}
              selectedBranch={selectedBranch}
              todaysReport
              allPaymentLabels={allPaymentLabels}
            />
          </section>
        </Card>
      </main>
    );
  }
}

const mapStateToProps = state => ({
  invoices: state.invoice.allInvoices,
  user: state.auth.user,
  error: state.error,
  products: state.product.allProducts,
  customers: state.customer.allCustomers,
  allBranches: state.branch.allBranches,
});

export default connect(mapStateToProps, {
  getAllSalesByDuration,
  getAllSales,
  getBranchSales,
  getBranchSalesByDuration,
  getCashierSales,
  merchantHasSale,
  getAllPaymentLabel,
  sendSalesReportToEmail,
})(TodayReports);
